'use strict';
/**
 * Выбирает объект из списка с помощью установки переключателя.
 *
 * @event WebAccess.components.wrappers.objectList.ObjectList#onSelect
 * @param {WebAccess.components.wrappers.objectList.ListItem} item Объект списка-переключатель, который был установлен в текущий момент
 * @param {WebAccess.components.wrappers.objectList.ListItem[]} checkedItems Все выбранные объекты списка
 * @example
 *
 *   WA.current.objectList.bind('onSelect', function (last, allItems) {
 *       
 *      console.log(last.name); //Вернет имя выбранного элемента в списке.
 * 
 *      //Вернет имена всех выделенных в текущий момент элементов в списке.
 *      for (var i =0; i < allItems.length; i++) {
 *        console.log(allItems[i].name);
 *      }
 *   });
 */

/**
 * Предоставляет работу со списками объектов.
 * Например, получить список отфильтрованных объектов – задач, заданий и уведомлений в проводнике, выделить объекты в списке закладок,
 * снять выделение с элементов табличной части справочника.
 *
 * @class WebAccess.components.wrappers.objectList.ObjectList
 * @property {string} containerSelector Блок, содержащий список
 * @property {string} objectSelector Элемент списка
 * @fires WebAccess.components.wrappers.objectList.ObjectList#onSelect Вызывается после того, как был выбран объект из списка
 * @fires WebAccess.components.wrappers.objectList.ObjectList#onChange Вызывается после внесения изменений в состав списка
 * @since 5.0.0.4102
 */

(function (global) {


  var ObjectList = BaseObject.extend({
    className: 'ObjectList',

    init(containerSelector) {
      this._super(containerSelector);

      this.containerSelector = '#main_container,#Attachments';
      this._jMainContainer = $(this.containerSelector);

      this._setupBindings();
      this._getType();

      this.getItems();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    containerSelector: '',
    objectSelector: '.List',
    _isAllSelected: false,
    _items: {},
    _jMainContainer: null,
    _jSearchTarget: null,
    _isTable: false,
    _selectedItemsCache: [],
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Устанавливает произвольное содержимое вместо текущего списка объектов.
     *
     * @method WebAccess.components.wrappers.objectList.ObjectList.setHtml
     * @return {WebAccess.components.wrappers.objectList} Специальный deferred-объект.
     */
    setHtml(html) {
      this._jMainContainer.html(`<div id="object_list_padding">${html}</div>`);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получает элементы списка.
     *
     * @method WebAccess.components.wrappers.objectList.ObjectList.getItems
     * @return {WebAccess.components.wrappers.objectList.ListItem[]}
     */
    getItems() {
      let items = {};

      this._jSearchTarget = this._jMainContainer.find(this.objectSelector);
      if (this._isTable) {
        this._jSearchTarget = this._getItemsElementsInTable(this._jSearchTarget);
      }

      let obj;
      for (let searchTarget of this._jSearchTarget.toArray()) {
        let jSearchTarget = $(searchTarget);
        if (jSearchTarget.hasClass('Task_obj') || jSearchTarget.hasClass('Job_obj')) {
          obj = new global.components.wrappers.objectList.CustomWorkListItem(searchTarget, this._isTable);
        } else {
          obj = new global.components.wrappers.objectList.ListItem(searchTarget, this._isTable);
        }

        if (obj.id) {
          items[obj.id] = obj;
        }
      }

      this._items = items;
      return items;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    isAllItemsSelected() {
      return this._isAllSelected;
    },

    /**
     * Получает объекты списка, отфильтрованные селектором.
     *
     * @method WebAccess.components.wrappers.objectList.ObjectList.getFilteredItems
     * @param {string} [filterSelector = this.objectSelector] jQuery-селектор для фильтрации списка элементов.
     * @return {WebAccess.components.wrappers.objectList.ListItem[]} Специальный deferred-объект.
     */
    getFilteredItems(filterSelector = this.objectSelector) {
      let filteredItems = this._jMainContainer.find(filterSelector).toArray();

      return filteredItems.reduce((result, element) => {
        let item = $(element);
        let newItem = this._getItemIdByjObject(item);
        if (newItem) {
          result.push(newItem);
        }
        return result;
      }, []);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Удалить элементы из списка.
     *
     * @method WebAccess.components.wrappers.objectList.ObjectList.removeItems
     * @param {object} links Список ссылок для удаления.
     * @param {boolean} [needUpdateTree = false] Признак необходимости обновления дерева папок.
     */
    removeItems(links, needUpdateTree = false) {
      // Для обновления значений в кэше установим, что кэш устарел
      this._selectedItemsCache = [];

      let selector;
      $.each(links, (_, l) => {
        selector = `#${l.id}.folder_item`;
        if (links && links[0] && links[0].type && links[0].type === OBJECT_TYPE.ANY) {
          selector = '.folder_item';
        }

        var linkKind = l.kind ? l.kind.toLowerCase() : objectTypeToString(l.type).toLowerCase();
        $(selector).each((index, link) => {
          let me = $(link);
          let elementKind = me.attr('kind').toLowerCase();

          if (elementKind === linkKind || linkKind === 'any') {
            if (elementKind === 'job' || elementKind === 'task' || elementKind === 'fol') {
              needUpdateTree = true;
            }
            me.remove();
          }
        });
      });

      if (needUpdateTree) {
        WA.CR.folderTree.update(function () {
          document.title = WA.CR.folderTree.getCurrentFolderName();
        });
      }
    },

    /**
     * Получает выделеннные элементы списка.
     * @method WebAccess.components.wrappers.objectList.ObjectList.getSelectedElements
     * @return {WebAccess.components.wrappers.objectList.ListItem[]}
     */
    getSelectedItems() {
      if (!this._selectedItemsCache.length) {
        this._selectedItemsCache = this.getFilteredItems('.selected');
      }

      return this._selectedItemsCache;
    },

    /**
    * Получает невыделеннные элементы списка.
    * @method WebAccess.components.wrappers.objectList.ObjectList.getUnselectedItems        
    * @return {WebAccess.components.wrappers.objectList.ListItem[]}
    * @since 5.6.0
    */
    getUnselectedItems() {
      return this.getFilteredItems(':not(.selected)');
    },

    /**
     * Выделяет все объекты списка.
     * @method WebAccess.components.wrappers.objectList.ObjectList.selectAll
     * @return {WebAccess.current.objectList}
     */
    selectAll() {
      // Для обновления значений в кэше установим, что кэш устарел
      this._selectedItemsCache = [];
      const rowsCount = GetRowsCount();
      this.setCheckedForFilteredItems(':not(.selected)', true);
      this._isAllSelected = (rowsCount === this.getSelectedItems().length);
      HideTopSpinner(L('ITEMS_SELECETED', rowsCount));
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Выделяет элемент списка.
     * @method WebAccess.components.wrappers.objectList.ObjectList.selectItemByID
     * @return {WebAccess.current.objectList}
     */
    selectItemByID(id) {
      // Для обновления значений в кэше установим, что кэш устарел
      this._selectedItemsCache = [];

      this.setCheckedForFilteredItems('#' + id + '.List', true);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Выделяет элемент списка.
     * @method WebAccess.components.wrappers.objectList.ObjectList.selectItem
     * @return {WebAccess.current.objectList}
     */
    selectItem(link) {
      // Для обновления значений в кэше установим, что кэш устарел
      this._selectedItemsCache = [];

      this.selectItemByID(link.id);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Снимает выделение со всех элементов списка.
     * @method WebAccess.components.wrappers.objectList.ObjectList.deselectAll
     * @return {WebAccess.current.objectList} Специальный deferred-объект.
     */
    deselectAll() {
      // Для обновления значений в кэше установим, что кэш устарел
      this._selectedItemsCache = [];

      this._isAllSelected = false;
      this.setCheckedForFilteredItems('.selected', false);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Снятие или выделение элемента из списка объектов.
     *
     * @method WebAccess.components.wrappers.objectList.ObjectList#toggleItem
     * @param {object} jItemCheckBox jQuery-объект чекбокса выделяемого элемента.
     * @param {object} [jItem] jQuery-объект выделяемого элемента списка.
     * @param {bool} [isChecked] True - необходимо выделить элемент, False - снять выделение.
     */
    toggleItem(jItemCheckBox, jItem, isChecked) {
      // Для обновления значений в кэше установим, что кэш устарел
      this._selectedItemsCache = [];

      // Если не указан jQuery-объект элемента списка, найдем его
      if (!jItem) {
        jItem = jItemCheckBox.parents('.List');
      }

      // Если не указана отмеченность элемента, определим ее
      if (typeof isChecked === 'undefined') {
        isChecked = !jItem.hasClass('selected');
      }

      if (isChecked) {
        jItem.addClass('selected');
      } else {
        jItem.removeClass('selected');
        if (this._isAllSelected) {
          this._isAllSelected = false;
        }
      }
      jItemCheckBox.prop('checked', isChecked);

      jItemCheckBox.trigger('itemChecked', []);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Инвертирует выделение всех объектов списка.
     *
     * @method WebAccess.components.wrappers.objectList.ObjectList.invertSelection
     * @return {WebAccess.current.objectList} Специальный deferred-объект.
     */
    invertSelection() {
      // Для обновления значений в кэше установим, что кэш устарел
      this._selectedItemsCache = [];

      var jCheckedItemsLength = this._jSearchTarget.filter('.selected').length;
      // Если небыло ничего выбранно и нажали на инвертировать выделение, то выделяем все.
      this._isAllSelected = (jCheckedItemsLength === 0);
      this.setCheckedForFilteredItems('', 'toggle');
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    executeContentAction(actionName) {
      let folderLink = new WA.Link(WA.CR.ID, OBJECT_TYPE.FOLDER, '');
      return WA.actions.executeContentAction(actionName, folderLink);
    },

    /**
     * Устанавливает или снимает выделение с элементов списка, отфильтрованных filterSelector.
     *
     * @method WebAccess.components.wrappers.objectList.ObjectList.setCheckedForFilteredItems     
     */
    setCheckedForFilteredItems(filterSelector, isChecked) {
      // Для обновления значений в кэше установим, что кэш устарел
      this._selectedItemsCache = [];

      // Получить список компонент
      let jItems = this._jMainContainer.find(this.objectSelector);
      if (filterSelector) {
        jItems = jItems.filter(filterSelector);
      }

      // Получить чекбоксы
      let jItemCheckboxes = jItems.find('input');
      jItemCheckboxes.each((index, checkbox) => {
        let jItemCheckBox = $(checkbox);
        let currentItemIsChecked;
        if (isChecked === 'toggle') {
          currentItemIsChecked = !jItemCheckBox.is(':checked');
        } else {
          currentItemIsChecked = isChecked;
        }
        this.toggleItem(jItemCheckBox, jItems.eq(index), currentItemIsChecked);
      });
      jItems.redraw();
      UpdateSelectionNumbers();
      let lastItemId = this._getItemIdByjObject(jItems.last());
      this.fire(
        'onSelect',
        lastItemId,
        this.getSelectedItems()
      );
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Тип списка: таблица или нет.
     *
     * @method WebAccess.components.wrappers.objectList.ObjectList._getType
     * @private
     * @return {boolean}
     */
    _getType() {
      return this._isTable = !!this._jMainContainer && !!this._jMainContainer.attr('class') && this._jMainContainer.attr('class').indexOf('slickgrid') !== -1;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Установка событий, при кликах на чекбоксы. Чтобы срабатывали глобальные события.
     *
     * @method WebAccess.components.wrappers.objectList.ObjectList._setupBindings
     * @private
     * @return {WebAccess.current.objectList}
     */
    _setupBindings() {
      this.bind('itemsChange', () => {
        this._onItemsChanged();
      });

      this.bind('itemSelect', (item) => {
        item.isChecked = true;
        if (!this._getType()) {
          let allItemsCount = GetRowsCount() || WA.CR.objectList.getFilteredItems().length;
          if (this.getSelectedItems().length === +allItemsCount) {
            //Для поисков не устанавливаем кнопку выделить всё
            if (!GetParamInURL('searchname')) {
              $('#chkAll').prop('checked', true);
              this._isAllSelected = true;
            }
          }
        }
        this._onItemSelected(item);
      });

      this.bind('itemUnSelect', (item) => {
        // Для обновления значений в кэше установим, что кэш устарел
        this._selectedItemsCache = [];
        item.isChecked = false;
        if (!this._getType()) {
          $('#chkAll').prop('checked', false);
        }
        this._onItemSelected(item);
      });

      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * При AJAX автоподгрузке элементов, надо обновлять список объектов.
     *
     * @private
     * @method WebAccess.components.wrappers.objectList.ObjectList._onItemsChanged
     * @return {WebAccess.components.wrappers.objectList.ListItem[]}
     */
    _onItemsChanged() {
      let items = this.getItems();
      this.fire(
        'onChange',
        this.getSelectedItems(),
        items,
      );
      return items;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//1

    /**
     * При клике на чекбокс, вызовем свое событие.
     *
     * @private
     * @method WebAccess.components.wrappers.objectList.ObjectList._onItemSelected
     * @return {WebAccess.current.objectList}
     */
    _onItemSelected(item) {
      this.fire(
        'onSelect',
        item,
        this.getSelectedItems(),
      );
      return this;
    },

    /**
     * Получает элементы списка отфильтрованные селектором.
     *
     * @private
     * @method WebAccess.components.wrappers.objectList.ObjectList._onItemSelected
     * @return {WebAccess.components.wrappers.objectList.ListItem}
     */
    _getItemIdByjObject(jObject) {
      const id = jObject.attr('id');
      return this._items[id];
    },

    /**
     * Получает элементы таблицы.
     *
     * @private
     * @method WebAccess.components.wrappers.objectList.ObjectList._getItemsElementsInTable
     * @params {object} Список элементов, в котором следует произвести поиск.
     * @return {jQuery}
     */
    _getItemsElementsInTable(items) {
      return items
        .not('.dxgvSelectedRow')
        .not('.dxgvGroupRow')
        .not('.dxgvEmptyDataRow');
    }

  });

  global.CMP.wrappers.objectList.ObjectList = ObjectList;

})(window.WebAccess);